<ng-container *ngIf="order$ | async as order">
  <ng-container *ngIf="!(isOrderLoading$ | async)">
    <ng-container *ngIf="!isSplitWfOrderConfirmationPage; else expandableOrderOverviewTmpl">
      <gen-order-overview [order]="order"></gen-order-overview>
      <gen-order-engine-replacement-form [order]="order"></gen-order-engine-replacement-form>
    </ng-container>
    <ng-template #expandableOrderOverviewTmpl>
      <mat-accordion>
        <mat-expansion-panel [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Order Information
            </mat-panel-title>
          </mat-expansion-panel-header>
          <gen-order-overview [order]="order"></gen-order-overview>
          <gen-order-engine-replacement-form [order]="order"></gen-order-engine-replacement-form>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-template>
  </ng-container>
</ng-container>